import { useEffect, useRef, useState } from "react";
import throttle from "lodash/throttle";

export function useComponentSize<T extends HTMLElement>() {
  const ref = useRef<T>(null);
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    const fun = throttle(() => {
      if (ref.current) {
        const { width, height } = ref.current.getBoundingClientRect();
        setWidth(width);
        setHeight(height);
      } else {
        setWidth(0);
        setHeight(0);
      }
    }, 16);
    window.addEventListener("resize", fun);
    fun();

    const observer = new IntersectionObserver(
      (entries, observer) => {
        if (entries[0].intersectionRatio > 0) {
          fun();
        }
      },
      {
        root: document.documentElement,
      }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      observer.disconnect();
      window.removeEventListener("resize", fun);
    };
  }, []);

  return { ref, width, height };
}
